import React from 'react';
import { Collapse } from "@blueprintjs/core";
import DanhSachBangChung from './DanhSachBangChung.jsx';
import DanhSachTaiLieuDinhKem from './DanhSachTaiLieuDinhKem.jsx';
import { Text, TextMessage } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';

class ThongTinDon extends React.Component {

  render() {
    return (
      <div className="box-forward">

          <div className="group-box">
            <Collapse isOpen={this.props.isOpen}>
              <div className="title">
                <div className="rows">
                  <div className="col-12">
                    <h3>{this.props.title}</h3>
                  </div>
                </div>
              </div>
              <div className="items-form">
                <div className="rows">
                  <Text
                    className="col-input"
                    label="Loại đơn thư:"
                    value={this.props.parent.loaiDon} />
                  <ShowIf condition={this.props.parent.loaiDonGiaTri ==  "DON_KHIEU_NAI"}>
                    <Text
                      className="col-input"
                      label="Loại đối tượng:"
                      value={this.props.parent.loaiDoiTuong ? this.props.parent.loaiDoiTuong.ten : ''} />
                  </ShowIf>
                  <ShowIf condition={this.props.parent.loaiDonGiaTri ==  "DON_TO_CAO"}>
                    <Text
                      className="col-input"
                      label="Đối tượng bị tố cáo:"
                      value={this.props.parent.loaiDoiTuong ? this.props.parent.loaiDoiTuong.ten : ''} />
                  </ShowIf>
                  <Text
                    className="col-input"
                    label="Lĩnh vực:"
                    value={this.props.parent.linhVuc} />
                  {
                    this.props.parent.linhVucChiTiet &&
                    <div className="col-input">
                      <label className="pt-label">
                        <span className="val-title-bold">Lĩnh vực chi tiết:</span>
                        <span className={(this.props.parent.linhVucChiTietSub) ? 'val-content arrow-to-dispute' : 'val-content'}>{this.props.parent.linhVucChiTiet}</span>
                      </label>
                    </div>
                  }
                  {
                    this.props.parent.linhVucChiTietKhac &&
                    <div className="col-input">
                      <label className="pt-label">
                        <span className="val-title-bold">Lĩnh vực chi tiết khác:</span>
                        <span className="'val-content">{this.props.parent.linhVucChiTietKhac}</span>
                      </label>
                    </div>
                  }
                  {
                    (this.props.parent.linhVucChiTiet && this.props.parent.linhVucChiTietSub) &&
                    <Text
                      className="col-input"
                      label="&nbsp;&nbsp;&nbsp;"
                      value={(this.props.parent.linhVucChiTietSub) ? this.props.parent.linhVucChiTietSub : ''} />
                  }
                </div>
              </div>
            </Collapse>
            <div className="items-form">
              <div className="rows mb10">
                <TextMessage label="Tóm tắt nội dung đơn thư:" value={this.props.parent.noiDung} className="col-12"/>
              </div>
            </div>
            <Collapse isOpen={this.props.isOpen}>
              <ShowIf condition={this.props.parent && this.props.parent.data && this.props.parent.data.loaiVuViecInfo !== undefined}>
                <div className="items-form">
                  <div className="rows">
                    <Text
                      className="col-input"
                      label="Loại vụ việc:"
                      value={this.props.parent.data.loaiVuViecInfo ? this.props.parent.data.loaiVuViecInfo.ten : ''} />
                  </div>
                </div>
              </ShowIf>
              {
                this.props.parent && this.props.parent.listTaiLieuBangChung && this.props.parent.listTaiLieuBangChung.length > 0 ?
                  <DanhSachBangChung parent={this.props.parent.listTaiLieuBangChung} />
                : ''
              }
              {
                this.props.checkXLDC === true && this.props.parent && this.props.parent.listTaiLieuVanThu && this.props.parent.listTaiLieuVanThu.length > 0 &&
                  <DanhSachTaiLieuDinhKem title="Danh sách văn bản xử lý" parent={this.props.parent.listTaiLieuVanThu} />
              }
            </Collapse>
          </div>

      </div>
    );
  }
}

export default ThongTinDon;



// WEBPACK FOOTER //
// ./src/components/modules/letter-information/letter-detail/ThongTinDonVuViec.jsx